import { saveAs } from 'file-saver';
import Excel from 'exceljs';
import { projectListXLS } from './xlsColumns';
import { currentDateFormatted } from '../constants/date-values';
import { ProjectWebDto } from '../api/api-types';

export const exportProjectList = async (projectList: ProjectWebDto[]) => {
  const workbook = new Excel.Workbook();
  try {
    const fileName = `Project list ${currentDateFormatted}`;

    const worksheet = workbook.addWorksheet('Projects');

    worksheet.columns = projectListXLS;

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'A6CCF7' },
      };
      cell.font = { bold: true };
    });

    projectList.map((item) =>
      worksheet.addRow({
        project: item.projectName,
        'customer name': item.customerName,
        'project manager': item.managerIdAndName?.name,
        'start date': item.startDate,
        'end date': item.endDate,
      }),
    );

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      if (column.eachCell) {
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 32;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      }
      column.width = maxLength > 32 ? 32 : maxLength;
      column.alignment = {
        vertical: 'middle',
        horizontal: 'left',
        wrapText: true,
      };
    });

    const buf = await workbook.xlsx.writeBuffer();

    saveAs(new Blob([buf]), `${fileName}.xlsx`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return error.message;
  } finally {
    workbook.removeWorksheet('Projects');
  }
};
